const USER_ACTION_TYPES = {
  SET_CURRENT_USER: "user/SET_CURRENT_USER",
  CHECK_USER_SESSION: "user/CHECK_USER_SESSION",
  SIGN_IN_START: "user/SIGN_IN_START",
  SIGN_IN_SUCCESS: "user/SIGN_IN_SUCCESS",
  SIGN_IN_FAILED: "user/SIGN_IN_FAILED",
  SIGN_UP_START: "user/SIGN_UP_START",
  SIGN_UP_SUCCESS: "user/SIGN_UP_SUCCESS",
  SIGN_UP_FAILED: "user/SIGN_UP_FAILED",
  ONBOARDING_START: "user/ONBOARDING_START",
  ONBOARDING_SUCCESS: "user/ONBOARDING_SUCCESS",
  ONBOARDING_FAILED: "user/ONBOARDING_FAILED",
  SIGN_OUT_START: "user/SIGN_OUT_START",
  SIGN_OUT_SUCCESS: "user/SIGN_OUT_SUCCESS",
  SIGN_OUT_FAILED: "user/SIGN_OUT_FAILED",
  SET_SHOULD_NAVIGATE_HOME: "user/SET_SHOULD_NAVIGATE_HOME",
  SET_REQUIRES_ONBOARDING: "user/SET_REQUIRES_ONBOARDING",
  SET_STYLE_PROFILE: "user/SET_STYLE_PROFILE",
};

export default USER_ACTION_TYPES;
